import * as Sentry from '@sentry/react';

const SENTRY_DSN = import.meta.env.VITE_SENTRY_DSN;

export function initSentry() {
  if (!SENTRY_DSN) {
    if (import.meta.env.DEV) {
      console.debug('[Sentry] Skipped — no VITE_SENTRY_DSN configured');
    }
    return;
  }

  Sentry.init({
    dsn: SENTRY_DSN,
    environment: import.meta.env.MODE,
    release: `starline-web@${__APP_VERSION__}`,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({ maskAllText: false, blockAllMedia: false }),
    ],
    // Performance monitoring
    tracesSampleRate: import.meta.env.PROD ? 0.2 : 1.0,
    // Session replay — capture 10% normally, 100% on errors
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    // Only send errors from our domain
    allowUrls: [/starline\.com\.bd/, /vercel\.app/, /localhost/],
    // Filter noisy errors
    ignoreErrors: [
      'ResizeObserver loop',
      'Non-Error promise rejection captured',
      'Load failed',
      'Failed to fetch',
      'NetworkError',
      'AbortError',
    ],
    beforeSend(event) {
      // Strip PII from breadcrumbs
      if (event.breadcrumbs) {
        event.breadcrumbs = event.breadcrumbs.map(b => {
          if (b.category === 'xhr' || b.category === 'fetch') {
            if (b.data?.url) {
              b.data.url = b.data.url.replace(/apikey=[^&]+/, 'apikey=[REDACTED]');
            }
          }
          return b;
        });
      }
      return event;
    },
  });
}

export { Sentry };

// Global type for __APP_VERSION__ injected by Vite
declare global {
  const __APP_VERSION__: string;
}
